<ng-container *ngIf="isConsultationClosed()">
    <div class="ui-g justify-center-grid">
        <div class="ui-g-12">
            <p class="alert alert-danger text-align-center">Consultation is closed.</p>
            <button class="button-glow ui-button-info ui-button-rounded patientvbutton width-max-content"
                (click)="backToAppoinments()" pButton>
                <span class="patientvbtnspan icon-video_call"></span>
                <span>Back To Appointments</span>
            </button>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="!isConsultationClosed()">
    <p-toast></p-toast>

    <app-loading type='LOADING_DATA' *ngIf="this.api_result.Posting"></app-loading>

    <div class="ui-g" *ngIf="!this.api_result.Posting && this.api_result.PromiseResult.success">

        <div class="ui-g-12">
            <div class="ui-g-12 ui-lg-6">
                <div class="ui-g-12 ui-lg-4">

                    <app-image-enlarger [type]="'IMAGE'" [src]="patientData.avatar_url"
                        [overlay_class_name]="'pvavatar'" [class_name]="'pvavatar'" [width]="'160'" [height]="'160'">
                    </app-image-enlarger>
                </div>
                <div class="ui-g-12 ui-lg-8">
                    <p class="boldn notranslate">{{patientData.first_name+', '+findAge()+', '+patientData.gender}}
                    </p>
                    <p class="namep notranslate">{{patientData.state_name+', '+patientData.country.country_name}}</p>
                    <!-- <p class="namep">{{patientData.primary_contact_number}}</p> -->
                    <p class="namep">
                        Unique Identification:
                        <app-image-enlarger [type]="'LINK'" [src]="patientData.identification_url"
                            [link_class]="'text-decoration-underline clickable'"
                            [link_name]="patientData.identification_type" [link_icon]="'pi pi-file'">
                        </app-image-enlarger>
                    </p>
                </div>
            </div>
            <div class="ui-g-12 ui-lg-6 row">
                <div>
                    <h4 class="boldnconstatus">Consultation Status : {{patientData.consultation[0].consultation_status}}
                    </h4>
                </div>
                <ng-container *ngIf="!isConsultationOpen()">
                    <div>
                        <h4 class="boldnconstatus notranslate">Consultation Date : {{patientData.consultation[0].consultation_date |
                            date:
                            'medium'}}
                        </h4>
                    </div>
                    <div class="ui-g-12 ui-lg-4 display-grid">
                        <button class="button-glow ui-button-info ui-button-rounded patientvbutton"
                            (click)="goToTab(this.tabs.index.DOCTORS_FEEDBACK)"
                            [disabled]="this.current_tab_index==this.tabs.index.DOCTORS_FEEDBACK || !isdoctorsFeedback()" pButton>
                            <span class="patientvbtnspan icon-video_call"></span>
                            <span>Add Clinical Notes</span>
                        </button>
                        <button class="button-glow ui-button-info ui-button-rounded patientvbutton"
                            (click)="goToTab(this.tabs.index.MESSAGE_CENTER)"
                            [disabled]="this.current_tab_index==this.tabs.index.MESSAGE_CENTER" pButton>
                            <span class="patientvbtnspan icon-video_call"></span>
                            <span>Send Message</span>
                        </button>
                    </div>
                    <div class="ui-g-12 ui-lg-6 display-grid">
                        <button class="button-glow ui-button-info ui-button-rounded patientvbutton "
                            (click)="TestZoomCall()" [disabled]="this.api_result_zoom.Posting" pButton>
                            <span class="patientvbtnspan icon-video_call"></span>
                            <span>Test Zoom Call</span>
                        </button>
                        <button class="button-glow ui-button-info ui-button-rounded patientvbutton"
                            (click)="StartConsultation($event)" [disabled]="this.api_result_zoom.Posting" pButton>
                            <span class="patientvbtnspan icon-video_call"></span>
                            <span>Initiate Consultation</span>
                        </button>
                    </div>
                </ng-container>
            </div>
        </div>
        <p-confirmDialog key="confirm-dialog" [closable]="false"></p-confirmDialog>
    </div>

    <app-loading *ngIf="this.api_result_zoom.Posting" type="POSTING_DATA"></app-loading>

    <app-error-messages style="text-align: center;" [api_result]="this.api_result"></app-error-messages>

    <app-error-messages style="text-align: center;" [api_result]="this.api_result_zoom"></app-error-messages>

    <ng-container *ngIf="!this.api_result.Posting && !this.api_result.PromiseResult.success">
        <div class="ui-g justify-center-grid">
            <div class="ui-g-12">
                <!-- <p class="alert alert-danger text-align-center">Consultation is closed.</p> -->
                <button class="button-glow ui-button-info ui-button-rounded patientvbutton width-max-content"
                    (click)="backToAppoinments()" pButton>
                    <span class="patientvbtnspan icon-video_call"></span>
                    <span>Back To Appointments</span>
                </button>
            </div>
        </div>
    </ng-container>

    <p-tabView styleClass="tab-panel" [(activeIndex)]="this.current_tab_index" (onChange)="this.onTabChange($event)"
        *ngIf="this.api_result.PromiseResult.success">
        <p-tabPanel header="Demographic Information">
            <app-patient-basic-details [api_result]="this.api_result"></app-patient-basic-details>
        </p-tabPanel>
        <p-tabPanel header="Patient History">
            <app-past-medical-history [patient_guid]="this.consultation_data.patient_guid"
                [condition_description]="patientData.consultation[0].condition_description"></app-past-medical-history>
        </p-tabPanel>
        <p-tabPanel header="Uploaded Medical Records" *ngIf="this.available_tabs.UPLOAD_MEDICAL_REPORTS">
            <app-medical-reports [patient_guid]="this.consultation_data.patient_guid"></app-medical-reports>
        </p-tabPanel>
        <p-tabPanel header="eGlobalDoctors Consultations" *ngIf="this.available_tabs.EGLOBALDOCTORS_CONSULTATIONS">
            <app-eglobaldoctors-conultations [patient_guid]="this.consultation_data.patient_guid">
            </app-eglobaldoctors-conultations>
        </p-tabPanel>
        <p-tabPanel header="Message Center">
            <app-loading type='LOADING_DATA' *ngIf="this.api_result.Posting"></app-loading>
            <app-patientv-message-centre *ngIf="!this.api_result.Posting"
                [patient_guid]="this.consultation_data.patient_guid"
                [consultation_id]="this.consultation_data.consultation_id" [patientData]="patientData">
            </app-patientv-message-centre>
        </p-tabPanel>
        <p-tabPanel header="Doctors Feedback" *ngIf="this.available_tabs.DOCTORS_FEEDBACK &&  isdoctorsFeedback()">
            <app-doctor-feedback [patient_guid]="this.consultation_data.patient_guid"
                [consultation_id]="this.consultation_data.consultation_id"
                (appointment_success_close)="SuccessCloseAppointment($event)"></app-doctor-feedback>
        </p-tabPanel>
        <p-tabPanel header="Diet Data" *ngIf="this.available_tabs.DIET_CONSULTATION_DATA">
            <app-diet-consultation-data [consultation_data]="this.consultation_data"></app-diet-consultation-data>
        </p-tabPanel>
    </p-tabView>
</ng-container>